import React, { useContext } from 'react';
import { BopisProvider } from '@core-ui/bopis';
import { PersonalizationContext } from '@core-ui/personalization-provider';
import { useClpState } from '../../providers/app-state-provider';
import { AppProps } from '../../index';
import { ErrorLogger } from '../../../types/app';

export type BopisWrapperType = Pick<AppProps, 'brand' | 'market' | 'pageType'> & {
  errorLogger: ErrorLogger;
  children?: React.ReactNode
};
export const BopisWrapper = ({
  brand,
  market,
  pageType,
  errorLogger,
  children
}: BopisWrapperType) => {
  const personalizationData = useContext(PersonalizationContext);
  const { lasConfig } = useClpState();

  return (
    <BopisProvider
      brand={brand}
      market={market}
      pageType={pageType}
      errorLogger={errorLogger}
      personalizationData={personalizationData}
      locationAttributeServiceConfig={lasConfig}
    >
      {children}
    </BopisProvider>
  );
};
